import { formPrefillEvent } from "@/components/forms/public-form";

export const CONTACT_FORM_ID = "contact-form";

/** Jump to the enquiry form and optionally pre-select a Subject. */
export function requestContact(subject?: string) {
  if (typeof window === "undefined") return;

  if (subject) {
    window.dispatchEvent(
      new CustomEvent(formPrefillEvent("contact"), { detail: { subject } }),
    );
  }

  const target = document.getElementById(CONTACT_FORM_ID);
  if (target) {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }
}
